const buildFullName = (contact) => {
  if (!contact.firstName) {
    throw new Error("FirstName is required.");
  }

  return contact.lastName
    ? `${contact.lastName ?? ""}, ${contact.firstName} ${
        contact.middleName ?? ""
      }`.trim()
    : `${contact.firstName} ${contact.middleName ?? ""}`.trim();
};

const ContactUtils = {
  buildFullName,
};

module.exports = ContactUtils;
